import PropTypes from 'prop-types';

import { Box, Button, Typography } from '@mui/material';

import { CircularLoaderComponent } from '../../LoadingSpinner/LoadingSpinnerComponent';

import { CopyToClipBoardButton } from '../../Button';

const PhoneNumberVerificationComponent = (props) => {
  const { isLoading, verificationCode, onModalClose } = props;

  if (!verificationCode || isLoading) {
    return <CircularLoaderComponent />;
  }

  return (
    <Box display="flex" flexDirection="column" gap="3rem">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap="2rem"
      >
        <Box display="flex" gap="1rem">
          {String(verificationCode)
            .split('')
            .map((num, i) => (
              <Typography
                key={i}
                sx={{
                  backgroundColor: '#eee',
                  borderRadius: '1rem',
                  padding: '0.5rem 1rem',
                  fontSize: '2rem',
                }}
              >
                {num}
              </Typography>
            ))}
        </Box>
        <CopyToClipBoardButton text={verificationCode} />
      </Box>
      <Button
        onClick={onModalClose}
        variant="contained"
        disableElevation
        fullWidth
      >
        Done
      </Button>
    </Box>
  );
};

PhoneNumberVerificationComponent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
  verificationCode: PropTypes.string,
};

export default PhoneNumberVerificationComponent;
